import { render } from "./ProductView.vue?vue&type=template&id=b481aa4e&ts=true"
import script from "./ProductView.vue?vue&type=script&lang=ts"
export * from "./ProductView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__